export default {"src":"/_next/static/media/vercel.a2517ec0.svg","height":44,"width":212};